<div class="modal on" role="dialog" aria-modal="true" aria-labelledby="df-md-title">
  <div class="dr-h">
    <div style="flex:1">
      <h3 id="df-md-title">{{ isBulk ? 'Why are these ' + ids.length + ' documents irrelevant?' : 'Why is this irrelevant?' }}</h3>
      <div class="d-path">{{ isBulk ? 'The same reason will be recorded for each one' : firstDoc?.name }}</div>
    </div>
    <button type="button" class="icon-btn" style="color:var(--ink-2)" aria-label="Close" (click)="cancel()"><df-icon name="x"></df-icon></button>
  </div>
  <div class="dr-b">
    <p class="lbl">Pick the main reason</p>
    <div class="rchips">
      <button type="button" class="rchip" *ngFor="let r of reasons" [attr.aria-pressed]="reason === r" (click)="pick(r)">{{ r }}</button>
    </div>
    <label class="lbl" for="df-ex-why" style="display:block;margin-top:12px">What gave it away? <span class="muted" style="font-weight:400">(optional, but it helps the agent most)</span></label>
    <textarea id="df-ex-why" class="fld" [(ngModel)]="why" placeholder="e.g. It covers EWM outbound picking, which belongs to Deliver, not Make."></textarea>
  </div>
  <div class="dr-f">
    <button type="button" class="btn cancel-btn" (click)="cancel()">Cancel</button>
    <button type="button" class="btn pri save-btn" [disabled]="!canSave" (click)="save()">Mark irrelevant</button>
  </div>
</div>
